const pagination = () => ({
  clickOnLink(event, page) {
    this.$dispatch('pagination-click-link', { event, page });
  },
});

export default pagination;
